import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  structuredData,
}) => {
  const defaultTitle =
    'Documint – Transform Credentials into Unforgeable Digital Certificates';
  const defaultDescription =
    'Create fraud-proof digital credentials with Self-Sovereign Identity. Instant verification, cryptographic security, W3C standards. Used by universities, enterprises & governments worldwide.';
  const defaultKeywords =
    'self-sovereign identity, verifiable credentials, digital identity, blockchain identity, DID, decentralized identifiers, W3C standards, OpenID4VC, credential verification, digital certificates, identity wallet, fraud prevention';
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://documint.id';
  const defaultImage = `${siteUrl}/og-image.png`;

  const seoTitle = title ? `${title} | Documint` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = image || defaultImage;
  const seoUrl = url || siteUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <link rel="canonical" href={seoUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content="Documint" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      <meta name="twitter:creator" content="@documint" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
